import { Formik } from "formik";
import styles from "./addStaff.module.scss";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MANAGE_STAFF } from "config/paths";
import { CommonMultiSelect, CommonSelect, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
import AppInputField from "components/shared/FormComponents/AppInputField";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { GRADE_OPTIONS, SUPPORT_STAFF_CLIENT_TYPES, DAY_OPTIONS, STAFF_DURATION_OPTIONS, STAFF_ENDS_ON_OPTIONS, STAFF_ENDS_TRACKER_OPTIONS, STAFF_TASK_TYPE_OPTIONS, MIME_TYPES } from "config/constants";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import addStaffSchema from "./addStaff.schema";
import { cloneDeep, debounce, isEmpty, result } from "lodash";
import { useAssignedSchoolsLookupQuery, useGetStaffListSchoolMutation, useLazyStaffLookupQuery, useSchoolLookupQuery } from "store/services/utility";
import { errorMessageToast, formatString, successMessageToast, userFullName } from "helpers/common";
import TableLayout from "components/TableLayout";
import { useLazyGetPrivateClientListQuery } from "store/services/clients/private";
import { useLazyGetSchoolClientsListQuery } from "store/services/clients/school.client";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { useCreateStaffMutation, useLazyGetPopulatedTasksListQuery, useLazyGetStaffListTaskTemplatesQuery } from "store/services/staff";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { genericFormErrorMsg } from "utils/validation/validationHelpers";
import { useDivisionLookupQuery } from "store/services/utility";
import { RemoveIcon } from "Assets/icons";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import AttachDocumentsReports from "components/shared/ReportComponents/AttachDocumentsReports";

const AddStaff = () => {

	const navigate = useNavigate();

	const [staffList, setStaffList] = useState([]);
	const [ClientList, setClientList] = useState([]);
	/* jere */
	const [initialValues, setInitialValues] = useState({
		task_title: "",
		task_datetime: "",
		time: "",
		duration: "",
		clinical_instruction: "",
		custom_duration: {
			every: "",
			durationType: "",
			frequency: ""
		},
		ends_on: "",
		ends_on_data: {
			endDate: "",
			occurence: ""
		},
		description: "",
		tracker_type: "",
		task_type: "",
		group_name: "",
		staff_id: "",
		clientType: "",
		task_for: "staff",
		resources: []
	});

	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [filter, setFilter] = useState({ search: "", sort: { column: "id", direction: "desc" } });
	const [totalPages, setTotalPages] = useState(0);
	const [selectedClients, setSelectedClients] = useState([]);
	const [clientType, setClientType] = useState("");
	const [divisionID, setDivisionID] = useState("");
	const [schoolID, setSchoolID] = useState("");
	const [gradeID, setGradeID] = useState("");
	const [titleOptions, setTitleOptions] = useState([])

	const [getStaffList, { isLoading: staffListLoading, isFetching: staffListFetching }] = useLazyStaffLookupQuery();
	const [getSchoolClientList, { isLoading: SchoolClientListLoading, isFetching: SchoolClientListFetching }] = useLazyGetSchoolClientsListQuery();
	const [getPrivateClientList, { isLoading: privateClientListLoading, isFetching: privateClientListFetching }] = useLazyGetPrivateClientListQuery();
	const [createStaff, { isLoading: createStaffLoading }] = useCreateStaffMutation();
	const [getPopulatedList, { data: populatedData, isFetching: populatedDataLoading }] = useLazyGetStaffListTaskTemplatesQuery();

	const [getStaffListSchool, { isLoading: staffListSchoolLoading, isFetching: staffListSchoolFetching }] = useGetStaffListSchoolMutation();

	const { data: schoolDivisonsList, isLoading: schoolDivisonsListLoading } = useDivisionLookupQuery();
	const schoolDivisionOptions = schoolDivisonsList?.map(item => ({ value: item.id, label: item.title }))
	const { data: schoolList, isLoading: schoolListLoading, isFetching: schoolListFetching } = useAssignedSchoolsLookupQuery();
	const schoolListOptions = schoolList?.map((i) => ({ value: i.id, label: i.name }));


	let setValue = null;

	useEffect(() => {
		if (clientType) {
			if (schoolID) {
				if (gradeID) {
					getStaff({ clientType, divisionID, schoolID, gradeID });
				} else {
					getStaff({ clientType, divisionID, schoolID });
				}
			} else {
				getStaff({ clientType });
			}
		}
	}, [clientType, schoolID, gradeID]);

	const getStaff = async ({ search, clientType, divisionID = '', schoolID = '', gradeID = '' }) => {
		let payload = {
			client_type: clientType || "",
			division: divisionID || '',
			school_id: schoolID || '',
			search
		};

		if (clientType === 'school' && gradeID) {
			payload.grade = gradeID;
		}

		try {
			let response = { error: true };
			if (clientType === 'school') {
				response = await getStaffListSchool({ payload }).unwrap();
			} else if (clientType === 'private') {
				response = await getStaffList({ search, clientType });
			} else {
				response = { error: false };
			}

			if (response.error) {
				console.error("Error in response:", response.error);
			} else {
				if (clientType == 'school') {
					setStaffList(response?.map(i => ({ label: userFullName(i), value: i.id })));
				} else if (clientType === 'private') {
					setStaffList(response?.data?.map(i => ({ label: userFullName(i), value: i.id })));
				}
			}

		} catch (error) {
			console.error("Error getting staff list:", error);
		}
	};

	const getList = async () => {
		try {

			let result = { error: true };
			let schoolClients = [];

			if (clientType === 'school') {
				result = await getSchoolClientList({ page: currentPage, limit: pageSize, ...filter });

				schoolClients = result.data.records.filter(schoolClient =>
					schoolClient.client_detail.client_type === 'school' &&
					schoolClient.client_detail?.client_school_detail?.school_profile === schoolID &&
					schoolClient.client_detail?.grade === gradeID
				);
			}
			else if (clientType === 'school' && schoolID) {
				result = await getSchoolClientList({ page: currentPage, limit: pageSize, ...filter });

				schoolClients = result.data.records.filter(schoolClient =>
					schoolClient.client_detail.client_type === 'school' &&
					schoolClient.client_detail?.client_school_detail?.school_profile === schoolID
				);
			}
			else if (clientType === 'private') {
				result = await getPrivateClientList({ page: currentPage, limit: pageSize, ...filter });
			}
			else {
				result = { error: true };
				setClientList([]);
			}
			if (result?.data) {
				let totalRecords = 0;
				if (clientType === 'school' && schoolID && schoolClients) {
					setClientList(schoolClients);
					totalRecords = schoolClients.length || 0;
				} else {
					setClientList(result?.data?.records);
					totalRecords = result?.data?.totalRecords || 0;
				}
				setTotalPages(Math.ceil(totalRecords / pageSize));
			};

		} catch (error) { console.log("error getting staff list", error); };
	};

	const handleSearchChange = useCallback(debounce((search, clientType) => {
		if (clientType) getStaff({ search, clientType });
		else setStaffList([]);

	}, 500), []);

	const customDurationOptions = [
		{
			label: "Day",
			value: "day"
		},
		{
			label: "Week",
			value: "week"
		},
		{
			label: "Month",
			value: "month"
		}
	];

	const [customDurationMonthOptions, setCustomDurationMonthOptions] = useState([
		{
			label: `Monthly on day ${moment().get('date')}`,
			value: moment().get('date')
		},
		{
			label: `Monthly on the ${moment().format('dddd')}`,
			value: moment().format('dddd')
		}
	]);

	const handleSubmit = async (values) => {
		if (!selectedClients.length) return errorMessageToast("Select atleast 1 client");

		const payload = cloneDeep(values);
		// Format values
		payload.task_type = values?.task_type?.value;
		payload.task_datetime = values?.task_datetime + " " + "00:01:00"
		payload.tracker_type = values?.tracker_type?.value;
		payload.staff_id = values?.staff_id?.value;
		payload.ends_on = values?.ends_on?.value || "";
		payload.duration = values?.duration?.value;
		payload.clients = selectedClients?.map((item) => item?.id);
		payload.custom_duration = {
			...payload.custom_duration,
			durationType: payload?.custom_duration?.durationType?.value || "",
			frequency: payload?.custom_duration?.frequency ? (payload?.custom_duration?.frequency?.value || payload?.custom_duration?.frequency?.map(i => i.value)) : ""
		};

		if (payload.duration == "no_repeat") {
			payload.ends_on = "on_date";
			payload.ends_on_data.endDate = payload.task_datetime?.split(" ")?.[0] || ""
		};

		delete payload.division;
		delete payload.school;
		delete payload.grade;
		delete payload.clientType;
		delete payload.time;

		const result = await createStaff(payload);
		if (!result.error) {
			successMessageToast(result?.data?.message);
			navigate(MANAGE_STAFF)
		};
	};

	const column = [
		{
			head: "Last Name",
			accessor: "lastname",
			isComponent: true,
			component: (item, ind) => (
				<div className="d-flex gap-2 align-items-center">
					<input
						type="checkbox"
						onChange={() => handleSelectClient(item)}
						checked={selectedClients?.find((x) => x.id == item?.id)}
					/>
					<h6 className="m-0 fw-sbold">{item?.lastname || ""}</h6>
				</div>
			),
		},
		{
			head: "First Name",
			accessor: "firstname",
			isComponent: true,
			component: (item, ind) => (
				<div className="d-flex gap-2 align-items-center">
					<h6 className="m-0 fw-sbold">{item?.firstname || ""}</h6>
				</div>
			),
		},
	];

	const handleSelectClient = (item) => {

		let list = cloneDeep(selectedClients);

		const index = list.findIndex(x => x.id === item.id);

		if (index > -1) delete list[index]
		else list.push(item);
		list = list.filter(Boolean);

		setValue("task_type", STAFF_TASK_TYPE_OPTIONS.find(x => x.value == (list.length > 1 ? "group" : "single")));
		setSelectedClients(list);
	};

	const handleAttachDocument = (name, value, prevValues = [], setFieldValue) => {
		try {
			let cloneValues = cloneDeep(prevValues);
			cloneValues.push({
				attachment_key: value,
				attachment_name: value,
			})
			setFieldValue(name, cloneValues);
		} catch (err) {
			console.error("Failed to attach document", err);
		}
	};

	const resetFilter = () => {
		setFilter({ search: "", sort: { column: "id", direction: "desc" } });
		setCurrentPage(1)
	};

	const handleFilterChange = (key) => (value) => {

		setCurrentPage(1);
		setFilter((prevState) => ({ ...prevState, [key]: value, }));
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const getPopulatedData = async (search) => {
		const filter = { page: 1, limit: 50, search }
		try {
			const result = await getPopulatedList({ ...filter }).unwrap();
			if (result?.records?.length) {
				const titleList = result.records.map(item => ({
					value: item.id,
					label: item.task_title // or whatever field contains the title
				}));
				setTitleOptions(titleList);
			} else {
				setTitleOptions([]);
			}
		} catch (err) {
			console.error("error fetching titles", err);
			setTitleOptions([]);
		}
	};

	const handleSearch = useCallback(debounce((search = "", access) => {
		console.log("SEARCH LIST ", search)
		if (search || access) getPopulatedData(search);
		// else {
		// 	setTitleOptions([]);
		// }
	}, 500), []);

	useEffect(() => {

		if (clientType || schoolID || gradeID) {
			getList();
		}
	}, [clientType, currentPage, filter]);

	useEffect(() => {
		handleSearch("", true)
	}, [])

	console.log('selectedClients', selectedClients)
	return (
		<section
			className={`${styles.addStaff} position-relative py-4 addManage`}
		>
			<Container fluid>
				{(staffListSchoolLoading || staffListSchoolFetching || SchoolClientListLoading || SchoolClientListFetching || privateClientListLoading || privateClientListFetching) && <LoadingOverlay />}
				<Row>
					<div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
						<div className="left">
							<ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
								<li className="">
									<h6 className="m-0 fw-bold themeBlue">{"Add New Task"}</h6>
								</li>
							</ul>
						</div>
					</div>
					<Col lg="12" className="my-2">
						<Formik
							initialValues={initialValues}
							validationSchema={addStaffSchema}
							onSubmit={handleSubmit}
							enableReinitialize
						>
							{
								({
									handleSubmit,
									values,
									setFieldValue,
									errors,
									submitCount,
									setValues
								}) => (
									<Form onSubmit={handleSubmit}>
										{setValue = setFieldValue}
										<div
											className="py-3"
											style={{ borderTop: "1px solid #41a2a84d" }}
										>
											<Row>
												{/* <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Title
														<RequiredFieldAstrick />
													</label>
													<AppInputField
														name="task_title"
														type="text"
														placeholder="Enter Title"
														className={`${styles.formControl} form-control`}
														maxLength={100}
													/>
												</Col> */}
												<Col md="3" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0 d-flex"
													>
														Title
														<RequiredFieldAstrick />
													</label>
													{/* <GuardianPicker
                                          type="parents"
                                          name={`parentLastname`}
                                          placeholder={"Search Last Name"}
                                        /> */}
													<CommonSelect
														// isDisabled={editMode}
														placeholder={"Search Title"}
														isClearable
														name="task_title"
														// handleBlur={() => setParentOptions([])}
														creatable={true}
														onInputChange={(e) => handleSearch(e)}
														option={titleOptions}  
														onClick={() => handleSearch("", true)}
														isLoading={populatedDataLoading}
														// value={values?.parentLastname && { label: values?.parentLastname, value: values?.parentLastname }}
														// onChange={(selected) => {
														// 	let guardian = parentOptions?.find(guardian => guardian.id === selected?.value);
														// 	let selectedValue = {
														// 		...selected,
														// 		label: guardian?.lastname
														// 	};
														// 	if (!guardian) {
														// 		setClientOptions([])
														// 		setFieldValue(`parentLastname`, selected);
														// 		setFieldValue(`parentId`, null);
														// 		setFieldValue(`parentFirstname`, "");
														// 		setFieldValue(`parentEmail`, "");
														// 		setFieldValue(`parentPhone`, "");
														// 		setFieldValue('clientType', "")
														// 		setFieldValue('clientId', "")
														// 		setConsentFormOptions([]);
														// 		setFieldValue("consentForms", []);

														// 		return;
														// 	}
														// 	setFieldValue(`parentLastname`, guardian.lastname);
														// 	setFieldValue(`parentId`, selectedValue.id);
														// 	setFieldValue(`parentFirstname`, guardian?.firstname);
														// 	setFieldValue(`parentEmail`, guardian?.email);
														// 	setFieldValue(`parentPhone`, guardian?.phone);
														// 	setFieldValue('clientType', "")
														// 	setFieldValue('clientId', "")
														// 	setParentOptions([])
														// 	setConsentFormOptions([]);
														// 	setFieldValue("consentForms", []);
														// }}
														value={titleOptions.find(option => option.value === values.task_title?.value)}
														onChange={(selected) => {
															if (selected) {
																const selectedTask = populatedData?.records?.find((task) => task.id === selected.value);
																console.log("SELECTED TASK ", selectedTask)
																setFieldValue("task_title", selected?.label);
																setFieldValue("description", selectedTask?.description || "");
															} else {
																// Clear fields if selection is cleared
																setFieldValue("task_title", "");
																setFieldValue("description", "");
															}
														}}
													/>
												</Col>
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Date
														<RequiredFieldAstrick />
													</label>
													<AppDatePicker
														name="task_datetime"
														className={`${styles.formControl} form-control`}
														handleChangeValue={(date) => {
															setCustomDurationMonthOptions([
																{
																	label: `Monthly on day ${moment(date, "YYYY-MM-DD").get('date')}`,
																	value: moment(date, "YYYY-MM-DD").get('date')
																},
																{
																	label: `Monthly on the ${moment(date, "YYYY-MM-DD").format('dddd')}`,
																	value: moment(date, "YYYY-MM-DD").format('dddd')
																}
															])
														}}
														portalId={"root"}
													/>
												</Col>
												{/* <Col md="4" sm="6" className="my-2">
<label
htmlFor=""
className="form-label themeBlue fw-bold mb-0"
>
Time
<RequiredFieldAstrick />
</label>
<AppInputField
name="time"
type="time"
placeholder=""
className={`${styles.formControl} form-control`}
maxLength={100}
/>
</Col> */}
												<Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Duration
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="duration"
														placeholder={"Select Duration"}
														option={STAFF_DURATION_OPTIONS}
														onChange={(val) => {
															setValues({
																...values,
																duration: val,
																custom_duration: { every: "", durationType: "", frequency: "" },
																ends_on: "",
																ends_on_data: { endDate: "", occurence: "" }
															});
														}}
													/>
												</Col>
												{
													values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Repeat Every
															<RequiredFieldAstrick />
														</label>
														<AppInputField
															name="custom_duration.every"
															type="number"
															placeholder="Enter Frequency"
															className={`${styles.formControl} form-control`}
															maxLength={100}
															min={1}
															onKeyDown={e => (e.key == "-" || e.key == "e" || e.key == "E") && e.preventDefault()}
														/>
													</Col>
												}
												{
													values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Duration Type
															<RequiredFieldAstrick />
														</label>
														<CommonSelect
															name="custom_duration.durationType"
															placeholder={"Select Duration Type"}
															option={customDurationOptions}
															onChange={(val) => {
																setFieldValue("custom_duration", { ...values.custom_duration, durationType: val, frequency: "" })
															}}
														/>
													</Col>
												}
												{
													values?.custom_duration?.durationType?.value == "week" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Day's
															<RequiredFieldAstrick />
														</label>
														<CommonMultiSelect
															name="custom_duration.frequency"
															placeholder={"Select Day's"}
															option={DAY_OPTIONS}
														/>
													</Col>
												}
												{
													values?.custom_duration?.durationType?.value == "month" && <Col md="4" sm="6" className="my-2">
														<label
															htmlFor=""
															className="form-label themeBlue fw-bold mb-0"
														>
															Month Day
															<RequiredFieldAstrick />
														</label>
														<CommonSelect
															name="custom_duration.frequency"
															placeholder={"Select Month Day"}
															option={customDurationMonthOptions}
														/>
													</Col>
												}

												{values?.duration?.value == "custom" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														End's On
														<RequiredFieldAstrick />
													</label>
													<CommonSelect
														name="ends_on"
														placeholder={"Select End's on"}
														option={STAFF_ENDS_ON_OPTIONS}
														onChange={(val) => {
															setValues({
																...values,
																ends_on: val,
																ends_on_data: { endDate: "", occurence: "" }
															});
														}}
													/>
												</Col>}
												{values?.ends_on?.value == "on_date" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														End Date
														<RequiredFieldAstrick />
													</label>
													<AppDatePicker
														name="ends_on_data.endDate"
														className={`${styles.formControl} form-control`}
														portalId={"root"}
													/>
												</Col>}
												{values?.ends_on?.value == "after" && <Col md="4" sm="6" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Occurance
														<RequiredFieldAstrick />
													</label>
													<AppInputField
														name="ends_on_data.occurence"
														type="number"
														placeholder=""
														className={`${styles.formControl} form-control`}
														maxLength={100}
														min={1}
														onKeyDown={e => (e.key == "-" || e.key == "e" || e.key == "E") && e.preventDefault()}
													/>
												</Col>}
												<Col md="12" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Description
													</label>
													<RequiredFieldAstrick />
													<AppInputField
														name="description"
														fieldType="textarea"
														placeholder=""
														className={`${styles.formControl} ${styles.textarea} form-control`}
														rows={5}
														maxLength={500}
													/>
												</Col>
												<Col md="12" className="my-2">
													<label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Cinician's Instructions
													</label>
													<RequiredFieldAstrick />
													<AppInputField
														name="clinical_instruction"
														fieldType="textarea"
														placeholder=""
														className={`${styles.formControl} ${styles.textarea} form-control`}
														rows={5}
														maxLength={500}
													/>
												</Col>
												<Col md="8" sm="6" className="my-2 ">
													<Row>
														<Col md="6" sm="6" >
															<label
																htmlFor=""
																className="form-label themeBlue fw-bold mb-0"
															>
																Tracker Type
																<RequiredFieldAstrick />
															</label>
															<CommonSelect
																name="tracker_type"
																placeholder={"Select Response Type"}
																option={STAFF_ENDS_TRACKER_OPTIONS}
															/>
														</Col>
														<Col md="6" sm="6">
															<label
																htmlFor=""
																className="form-label themeBlue fw-bold mb-0"
															>
																Task Type
																<RequiredFieldAstrick />
															</label>
															<CommonSelect
																name="task_type"
																placeholder={"Select Task Type"}
																option={STAFF_TASK_TYPE_OPTIONS}
															/>
														</Col>
													</Row>
												</Col>
												<Col md="3" sm="6" className="my-2">
													{values?.task_type?.value == "group" &&
														<>
															<label
																htmlFor=""
																className="form-label themeBlue fw-bold mb-0"
															>
																Group Name
															</label>
															<RequiredFieldAstrick />
															<AppInputField
																name="group_name"
																type="text"
																placeholder="Enter Group Name"
																className={`${styles.formControl} form-control`}
																maxLength={100}
															/>
														</>}
												</Col>
												<Col md="6" className="my-2">
													{/* <label
														htmlFor=""
														className="form-label themeBlue fw-bold mb-0"
													>
														Documents
													</label>
													<AppFileUploadField
														name="resources"
														isMulti={true}
														acl={"private"}
														allowedTypes={[MIME_TYPES.pdf]}
														className={`${styles.formControl} form-control`}
														accept="application/pdf"
														onChange={(name, value) => {
															handleAttachDocument(name, value, values?.resources, setFieldValue);
														}}
													/> */}
													<div className="py-3">
														<AttachDocumentsReports
															acl={"private"}
															name="resources"
															allowedTypes={["pdf", "doc", "docx", "jpg", "xlsx", "png"]}
														/>
													</div>
												</Col>

												<Col md="12" className="border-top pt-5">
													<Row>
														<Col md="3" sm="6" className="my-2">
															<label
																htmlFor=""
																className="form-label themeBlue fw-bold mb-0"
															>
																Client Type
																<RequiredFieldAstrick />
															</label>
															<CommonSelect
																name="clientType"
																placeholder={"Select Client Type"}
																// option={CLIENT_TYPES}
																option={SUPPORT_STAFF_CLIENT_TYPES}
																onChange={(e) => {
																	// resetFilter()
																	setClientType(e?.value)
																	setFieldValue("staff_id", "");
																	// setFieldValue("division", "");
																	// setFieldValue("school", "");
																	// setFieldValue("grade", "");
																	// setSchoolID("")
																	// setDivisionID("")
																	// setGradeID("")
																	setClientList([])
																	setSelectedClients([])
																}}
															/>
														</Col>
														{values?.clientType?.value == "school" &&
															<>
																{/* <Col md="4" sm="6" className="my-2">
<label
htmlFor=""
className="form-label themeBlue fw-bold mb-0 d-flex"
>
School Division
<RequiredFieldAstrick />
</label>
<CommonSelect
name="division"
option={schoolDivisionOptions}
isLoading={schoolDivisonsListLoading}
onChange={(e) => {
resetFilter()
setDivisionID(e?.value)
setFieldValue("staff_id", "");
}}
/>
</Col> */}
																{/* <Col md="3" sm="6" className="my-2">
																	<label
																		htmlFor=""
																		className="form-label themeBlue fw-bold mb-0 d-flex"
																	>
																		School
																		<RequiredFieldAstrick />
																	</label>
																	<CommonSelect
																		name="school"
																		placeholder={"Please Select School"}
																		option={schoolListOptions}
																		onChange={(e) => {
																			resetFilter()
																			setClientType('school')
																			setSchoolID(e?.value)
																			setGradeID("")
																			setFieldValue("staff_id", "");
																			setFieldValue("grade", "");
																		}}
																	/>
																</Col>
																<Col md="3" sm="6" className="my-2">
																	<label
																		htmlFor=""
																		className="form-label themeBlue fw-bold mb-0 d-flex"
																	>
																		Grade
																	</label>
																	<CommonSelect
																		name="grade"
																		option={GRADE_OPTIONS}
																		onChange={(e) => {
																			resetFilter()
																			setClientType('school')
																			setGradeID(e?.value)
																		}}
																	/>
																</Col> */}
															</>}
														<Col md="3" sm="6" className="my-2">
															<label
																htmlFor=""
																className="form-label themeBlue fw-bold mb-0"
															>
																Support Staff
																<RequiredFieldAstrick />
															</label>
															<CommonSelect
																name="staff_id"
																placeholder={"Select Staff"}
																option={staffList}
																isLoading={staffListLoading || staffListFetching}
																onInputChange={(e) => handleSearchChange(e, values?.clientType?.value)}
															/>
														</Col>
													</Row>
												</Col>
											</Row>
										</div>
										<Row className="align-items-center">
											<Col lg="7" sm="12" className="my-1">
												<TableHeader
													heading={"Client List"}
													handleFilterChange={handleFilterChange}
													filter={filter}
													resetFilter={resetFilter}
													searchPlaceholder="Client Last, First Name"
													filterComponent={
														values?.clientType?.value == "school" &&
														<>
															<li>
																<CommonSelect
																	placeholder={"Select School"}
																	option={schoolListOptions}
																	onChange={(e) => { handleFilterChange("school")(e); }}
																	value={filter?.school}
																	isFilter
																	isLoading={schoolListLoading}
																/>
															</li>
															{/* <li className="">
																<Dropdown onSelect={handleFilterChange("grade")}>
																	<Dropdown.Toggle
																		variant="transparent"
																		className="border-0 d-flex align-items-center  justify-content-center"
																		id="dropdown-basic"
																	>
																		{GRADE_OPTIONS?.find(x => x.value == filter?.grade)?.label || "Grade"}
																		<span className="icn ms-2">
																			<svg
																				xmlns="http://www.w3.org/2000/svg"
																				width="12"
																				height="8"
																				viewBox="0 0 12 8"
																				fill="none"
																			>
																				<path
																					d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
																					fill="black"
																				/>
																			</svg>
																		</span>
																	</Dropdown.Toggle>
																	<Dropdown.Menu >
																		{
																			!GRADE_OPTIONS?.length ? <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item> : GRADE_OPTIONS?.map((item, index) => {
																				return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
																			})
																		}
																	</Dropdown.Menu>
																</Dropdown>
															</li> */}
														</>
													}
												/>
											</Col>
											{
												selectedClients?.length > 0 && <>
													<Col lg="5" sm="12" className="my-1">
														<h4>Selected Clients</h4>
													</Col>
												</>
											}
										</Row>
										<Row>
											<Col lg="7" sm="12" className="my-1">
												<div className="table-outer" >
													<TableLayout
														height={"40vh"}
														data={ClientList}
														column={column}
													/>
													<CstmPagination
														totalPages={totalPages}
														activePage={currentPage}
														handlePageChange={handlePageChange}
													/>
												</div>
											</Col>
											{
												selectedClients?.length > 0 && <Col lg="5" sm="12" className="my-2">
													<ul className="list-unstyled mb-0">
														{selectedClients?.map((item) => (
															<li
																key={item.id} // Replace with appropriate unique identifier
																className="d-flex align-items-center justify-content-between py-2 px-3 border rounded mb-2"
																style={{ backgroundColor: "#f8f9fa" }}
															>
																<div className="d-flex align-items-center">
																	{/* Optional icon: uncomment if needed */}
																	{/* <span className="me-2"><DocumentIcon /></span> */}
																	<p className="mb-0 fw-medium" style={{ fontSize: "16px" }}>
																		{userFullName(item)}
																	</p>
																</div>

																<Button
																	variant="light"
																	className="p-1 d-flex align-items-center justify-content-center"
																	onClick={() => handleSelectClient(item)}
																>
																	<RemoveIcon />
																</Button>
															</li>
														))}
													</ul>
												</Col>
											}
										</Row>
										<Row className="mt-5 ">
											{(!isEmpty(errors) && submitCount > 0) && (
												<Row className="my-2">
													<Col lg="12">
														<span className="error">{genericFormErrorMsg}</span>
													</Col>
												</Row>
											)}
											<Col className="my-2" lg="12">
												<div
													className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
													style={{ borderTop: "1px solid #41a2a84d" }}
												>
													<Button
														className="d-flex align-items-center justify-content-center commonBtn"
														type="submit"
														disabled={createStaffLoading}
													>
														{createStaffLoading ? <LoadingIndicator /> : "Save"}
													</Button>
													<Button
														className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
														type="button"
														onClick={() => navigate(MANAGE_STAFF)}
													>
														Cancel
													</Button>
												</div>
											</Col>
										</Row>
									</Form>
								)}

						</Formik>
					</Col>
				</Row>
			</Container>
		</section>
	)
};

export default AddStaff;